import React from 'react'

import './BuyflowContainer.css'

const CenteredBlueContainer = ({ children }) => (
  <div className="buyflow__container--centered-blue">{children}</div>
)

export default CenteredBlueContainer
